/**
 * MINICAR — Injection CSS dans le Shadow DOM Shopify Privacy
 * Le bandeau cookie Shopify Privacy utilise un Shadow DOM
 * Les styles CSS externes ne peuvent pas le pénétrer.
 * Ce script injecte le CSS directement dans le shadow root.
 */
(function() {
  'use strict';

  var INJECTED = false;

  var css = `
    @import url('https://fonts.googleapis.com/css2?family=Barlow:wght@400;600;700&family=Barlow+Condensed:wght@700;800;900&display=swap');

    * { box-sizing: border-box; }

    /* ---- Wrapper global ---- */
    :host > div,
    :host > section,
    .privacy-consent__wrapper,
    [class*="wrapper"],
    [class*="Wrapper"] {
      position: fixed !important;
      bottom: 0 !important;
      left: 0 !important;
      right: 0 !important;
      top: auto !important;
      width: 100% !important;
      max-width: 100% !important;
      background: #0e0e0e !important;
      border-top: 2px solid #fd844a !important;
      border-radius: 0 !important;
      box-shadow: 0 -8px 40px rgba(0,0,0,0.5) !important;
      padding: 20px 40px !important;
      margin: 0 !important;
      display: flex !important;
      align-items: center !important;
      justify-content: space-between !important;
      flex-wrap: wrap !important;
      gap: 20px !important;
      z-index: 99999 !important;
      transform: none !important;
    }

    /* Overlay fond gris — on le cache */
    [class*="overlay"],
    [class*="Overlay"],
    [class*="backdrop"],
    [class*="Backdrop"] {
      display: none !important;
      background: transparent !important;
    }

    /* Titre */
    h1, h2, h3 {
      font-family: 'Barlow Condensed', sans-serif !important;
      font-size: 13px !important;
      font-weight: 800 !important;
      letter-spacing: 0.1em !important;
      text-transform: uppercase !important;
      color: #fd844a !important;
      margin: 0 0 6px !important;
    }

    /* Texte */
    p {
      font-family: 'Barlow', sans-serif !important;
      font-size: 12.5px !important;
      color: rgba(255,255,255,0.65) !important;
      line-height: 1.65 !important;
      margin: 0 !important;
    }

    /* Lien */
    a {
      color: #fd844a !important;
      text-decoration: underline !important;
      font-weight: 600 !important;
    }

    /* Zone boutons */
    [class*="action"],
    [class*="Action"],
    [class*="button-group"],
    [class*="ButtonGroup"],
    [class*="buttons"],
    [class*="Buttons"] {
      display: flex !important;
      align-items: center !important;
      gap: 10px !important;
      flex-shrink: 0 !important;
      flex-wrap: nowrap !important;
    }

    /* Tous les boutons — base */
    button {
      font-family: 'Barlow Condensed', sans-serif !important;
      cursor: pointer !important;
      white-space: nowrap !important;
      min-height: unset !important;
      border-radius: 0 !important;
      transition: opacity 0.15s !important;
    }

    /* Bouton principal — Accepter */
    button[class*="primary"],
    button[class*="Primary"],
    button:first-of-type {
      background: #fd844a !important;
      color: #fff !important;
      border: none !important;
      font-size: 13px !important;
      font-weight: 800 !important;
      letter-spacing: 0.1em !important;
      text-transform: uppercase !important;
      padding: 11px 26px !important;
      clip-path: polygon(8px 0%, 100% 0%, calc(100% - 8px) 100%, 0% 100%) !important;
      box-shadow: 3px 3px 0 rgba(0,0,0,0.2) !important;
    }
    button[class*="primary"]:hover,
    button[class*="Primary"]:hover,
    button:first-of-type:hover {
      opacity: 0.88 !important;
    }

    /* Bouton secondaire — Refuser */
    button[class*="secondary"],
    button[class*="Secondary"],
    button:nth-of-type(2) {
      background: transparent !important;
      color: rgba(255,255,255,0.45) !important;
      border: 1px solid rgba(255,255,255,0.18) !important;
      font-size: 12px !important;
      font-weight: 600 !important;
      letter-spacing: normal !important;
      text-transform: none !important;
      padding: 9px 18px !important;
      clip-path: none !important;
      box-shadow: none !important;
    }
    button[class*="secondary"]:hover,
    button[class*="Secondary"]:hover,
    button:nth-of-type(2):hover {
      color: rgba(255,255,255,0.8) !important;
      border-color: rgba(255,255,255,0.35) !important;
    }

    /* Lien Gérer les préférences */
    button[class*="plain"],
    button[class*="Plain"],
    a[class*="manage"],
    a[class*="Manage"] {
      background: none !important;
      color: rgba(255,255,255,0.3) !important;
      border: none !important;
      font-size: 11px !important;
      font-weight: 600 !important;
      text-decoration: underline !important;
      padding: 0 !important;
      clip-path: none !important;
      box-shadow: none !important;
      text-transform: none !important;
      letter-spacing: normal !important;
    }

    @media (max-width: 640px) {
      :host > div,
      :host > section,
      [class*="wrapper"],
      [class*="Wrapper"] {
        flex-direction: column !important;
        align-items: flex-start !important;
        padding: 16px 18px !important;
        gap: 14px !important;
      }
    }
  `;

  function injectIntoShadow(shadowRoot) {
    if (!shadowRoot || INJECTED) return;
    var style = document.createElement('style');
    style.textContent = css;
    shadowRoot.insertBefore(style, shadowRoot.firstChild);
    INJECTED = true;
  }

  function findAndInject() {
    // Cherche tous les éléments avec un shadow root
    var all = document.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) {
      if (all[i].shadowRoot) {
        var sr = all[i].shadowRoot;
        // Vérifie si c'est le bon shadow DOM (contient du texte cookie)
        var text = sr.textContent || '';
        if (text.includes('cookie') || text.includes('Cookie') || text.includes('consentement') || text.includes('Consentement') || text.includes('Privacy') || text.includes('privacy')) {
          injectIntoShadow(sr);
        }
      }
    }
  }

  // Tentatives multiples pour attraper le shadow DOM
  // (il peut s'afficher avec un léger délai)
  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(findAndInject, 100);
    setTimeout(findAndInject, 500);
    setTimeout(findAndInject, 1000);
    setTimeout(findAndInject, 2000);
  });

  // Observer les nouveaux éléments ajoutés au DOM
  var observer = new MutationObserver(function(mutations) {
    if (INJECTED) { observer.disconnect(); return; }
    findAndInject();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

})();
